import { useEffect, useState } from "react";

import SimpleModal from "../../../shared/components/simple-modal/simple-modal";
import DataTable from "../../components/data-table/data-table";
import { alertcaseColumns } from "../alertcases/alertcases-columns";

interface ISelectAlertCaseModalProps {
  selectedIds: string[];
  show: boolean;
  onClosed: () => void;
  onSubmit: (selectedAlertCaseIds: string[]) => void;
}

const SelectAlertCaseModal = ({show, selectedIds, onClosed, onSubmit}: ISelectAlertCaseModalProps) => {
  const [showModal, setShowModal] = useState(show);
  const [selectedAlertCaseIds, setSelectedAlertCaseIds] = useState<string[]>([]);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const renderModalBody = () => {
    return (
      <div className="selectAlertCaseModal">
        <DataTable
          style="compact"
          defaultSortCol="creation_date"
          columns={alertcaseColumns}
          dataUrl={{
            url: "alertcases",
            backend: "manager"
          }}
          isRowClickable={false}
          selectionMode="multi"
          preSelectedIds={selectedIds}
          onSelectionChange={setSelectedAlertCaseIds}
        />
      </div>
    );
  };

  const handleOnSubmit= () => {
    onSubmit(selectedAlertCaseIds);
    setShowModal(false);
  };
  
  return (
    <SimpleModal 
      show={showModal} 
      handleModalClosed={onClosed} 
      handleSubmit={handleOnSubmit} 
      mode="Link AlertCases"
      buttonText="Save"
      modalBody={renderModalBody()}
      actionButtonDisabled={selectedAlertCaseIds.length === 0}
      showCancelButton={true}
    />
  );
};

export default SelectAlertCaseModal;
